"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var _laboratoryClient = require("laboratory-client");

var portalId = _hubspot.default.get();

var LaboratoryApi =
/*#__PURE__*/
function () {
  function LaboratoryApi() {
    (0, _classCallCheck2.default)(this, LaboratoryApi);
  }

  (0, _createClass2.default)(LaboratoryApi, null, [{
    key: "fetchLaboratoryTreatment",
    value: function fetchLaboratoryTreatment(payload) {
      return (0, _laboratoryClient.fetchTreatment)({
        key: payload,
        identifier: portalId
      });
    }
  }]);
  return LaboratoryApi;
}();

var _default = LaboratoryApi;
exports.default = _default;
module.exports = exports.default;